const SECTOR_FROM_API: Record<string, string> = {
  banking: 'banking',
  BANKING: 'banking',
  Banking: 'banking',
  chemical: 'chemical',
  CHEMICAL_INDUSTRY: 'chemical',
  'Chemical industry': 'chemical',
  digitalInfrastructure: 'digitalInfrastructure',
  DIGITAL_INFRASTRUCTURE: 'digitalInfrastructure',
  'Digital infrastructure': 'digitalInfrastructure',
  digitalServiceProviders: 'digitalServiceProviders',
  DIGITAL_SERVICE_PROVIDERS: 'digitalServiceProviders',
  'Digital service providers': 'digitalServiceProviders',
  healthcare: 'healthcare',
  HEALTHCARE: 'healthcare',
  Healthcare: 'healthcare',
  transport: 'transport',
  TRANSPORT: 'transport',
  Transport: 'transport',
  other: 'other',
  OTHER: 'other',
  Other: 'other',
}

const LOCATION_FROM_API: Record<string, string> = {
  onPremise: 'onPremise',
  ON_PREMISE: 'onPremise',
  'On-premise': 'onPremise',
  rented: 'rented',
  RENTED: 'rented',
  Rented: 'rented',
  cloud: 'cloud',
  CLOUD: 'cloud',
  Cloud: 'cloud',
  notSure: 'notSure',
  NOT_SURE: 'notSure',
  'Not sure': 'notSure',
}

const YES_NO_FROM_API: Record<string, string> = {
  yes: 'yes',
  YES: 'yes',
  Yes: 'yes',
  no: 'no',
  NO: 'no',
  No: 'no',
}

const STRATEGY_FROM_API: Record<string, string> = {
  ...YES_NO_FROM_API,
  inDevelopment: 'inDevelopment',
  IN_DEVELOPMENT: 'inDevelopment',
  'In development': 'inDevelopment',
}

const TEAM_FROM_API: Record<string, string> = {
  ...YES_NO_FROM_API,
  externalProvider: 'externalProvider',
  EXTERNAL_PROVIDER: 'externalProvider',
  'External provider': 'externalProvider',
}

const NOT_SURE_FROM_API: Record<string, string> = {
  ...YES_NO_FROM_API,
  notSure: 'notSure',
  NOT_SURE: 'notSure',
  'Not sure': 'notSure',
}

const TESTING_FROM_API: Record<string, string> = {
  ...YES_NO_FROM_API,
  sometimes: 'sometimes',
  SOMETIMES: 'sometimes',
  Sometimes: 'sometimes',
}

function fromMap(table: Record<string, string>, value: unknown, fallback: string) {
  const raw = typeof value === 'string' ? value.trim() : ''
  return table[raw] || fallback
}

export function starterGuideSectorKey(value: unknown) {
  return fromMap(SECTOR_FROM_API, value, '')
}

export function starterGuideLocationKey(value: unknown) {
  return fromMap(LOCATION_FROM_API, value, '')
}

export function starterGuideStrategyKey(value: unknown) {
  return fromMap(STRATEGY_FROM_API, value, 'no')
}

export function starterGuideTeamKey(value: unknown) {
  return fromMap(TEAM_FROM_API, value, 'no')
}

export function starterGuideNotSureKey(value: unknown) {
  return fromMap(NOT_SURE_FROM_API, value, 'notSure')
}

export function starterGuideTestingKey(value: unknown) {
  return fromMap(TESTING_FROM_API, value, 'no')
}

/**
 * Same phone contract as backend/services/starterGuide/starterGuideContract.js normalizeStarterGuidePhone.
 * Spaces, parentheses, hyphens and dots are formatting. Prefix 00 becomes + when 7–15 digits remain.
 * A single leading 0 is kept. Invalid input returns null and must not be rewritten into another number.
 */
export function normalizeStarterGuidePhone(value: unknown): string | null {
  let raw = String(value ?? '').trim().replace(/[\s().-]/g, '')
  if (raw.startsWith('00')) raw = `+${raw.slice(2)}`
  const match = raw.match(/^\+?(\d{7,15})$/)
  if (!match) return null
  return raw.startsWith('+') ? `+${match[1]}` : match[1]
}

export function starterGuideResourcesText(value: unknown) {
  if (Array.isArray(value)) return value.map((item) => String(item || '').trim()).filter(Boolean).join('\n')
  return typeof value === 'string' ? value : ''
}
